// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { CollateralAgreement } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Model/Collateral';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';
import { useOperatorParty } from '../../utility-operator/useOperatorParty';

const useCollateralAgreements: () => UseQueryResult<
  TemplateContract<CollateralAgreement>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const operator = useOperatorParty()?.data || '';
  return useQueryWithOptions({
    queryKey: ['queryCollateralAgreements', operator],
    enabled: !!operator,
    queryFn: async (_, options) => {
      return ledgerApi.queryCollateralAgreements(options, operator);
    },
  });
};

export default useCollateralAgreements;
